const HBBTV_CONST = {
    APP_MNGR_ID: 'appmgr',
    APP_MNGR_TYPE: 'application/oipfApplicationManager',
    APP_CONF_TYPE: 'application/oipfConfiguration',
    APP_CONF_ID: 'oipfcfg',
    APP_DRM_TYPE: 'application/oipfDrmAgent',
    APP_DRM_ID: 'oipfdrm',
    APP_BROADCAST_VIDEO_TYPE: 'video/broadcast',
    APP_BROADCAST_VIDEO_ID: 'mainVideoObject',
    REMOTE_DEBUGGER_URL_NAME: 'debugurl',
    APP_CAPABILITIES_ID: 'capabilities',
    APP_CAPABILITIES_TYPE: 'application/oipfCapabilities',
    MEDIA_SYNCHRONISER_ID: 'mediasynchroniser',
    MEDIA_SYNCHRONISER_TYPE: 'application/hbbtvMediaSynchroniser',
    HBBTV_CS_MANAGER_ID: 'hbbtvCSManager',
    HBBTV_CS_MANAGER_TYPE: 'application/hbbtvCSManager',
    DEFAULT_USER_AGENT: 'Mozilla/5.0 (Web0S; Linux/SmartTV) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/53.0.2785.34 Safari/537.36 HbbTV/1.4.1 (+DRM+CPAS 2.0.1; LGE; 55SK850V-ZA; WEBOS4.0 03.00.09; W4_M16PP; W4_M16PP;)',
    STORE_TYPE_COOKIES: 'COOKIES',
    STORE_TYPE_LOCAL_STORAGE: 'LOCAL_STORAGE',
    STORE_TYPE_UNKNOW: 'UNKNOW',
    EVENT_TYPES: {
        DELETE_COOKIE: 'DELETE_COOKIE',
        MODIFY_COOKIE: 'MODIFY_COOKIE',
        EVENT: 'EVENT'
    }
};

export { HBBTV_CONST }